
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexVZt_um_45IBGEJMHKR0taLIrei0a5KiNM4_YVDH5HJB2sMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/index.vue?macro=true";
import { default as inputqAWjbXDQ7BnbYvXNv1B7Nj4v4G2fnWFRRzXy7ZERYh8Meta } from "E:/W2/CDVM_V2/VM.Cms/pages/input.vue?macro=true";
import { default as builderb0azhEC2YcR5WS9gUbltel1Lnz63hzAfVdRURf8BhZUMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/builder.vue?macro=true";
import { default as indexo8gQcDn_45FHbPsMShMgx4x6hK33DhmtYULsSEZ3j6z4EMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/role/index.vue?macro=true";
import { default as indexueheeumIuwt_nd5ZhyvbPEOOkLTCQ2UJowooiwmJ4SUMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/class/index.vue?macro=true";
import { default as indexnEqOMnhfQVj9oyAGrPMWPoxTSulKtOfH3MduHa1OXwsMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/config/index.vue?macro=true";
import { default as parent_45inputKKiBnDJcqAW8QvwUwZE_zf1BUDlKc9gPXw5d3JmewH0Meta } from "E:/W2/CDVM_V2/VM.Cms/pages/parent-input.vue?macro=true";
import { default as indexGgD0fjSEehf7gizHyPQUYHLvkD4i5xIY5CLcuF9S294Meta } from "E:/W2/CDVM_V2/VM.Cms/pages/account/index.vue?macro=true";
import { default as logindPzKT4QTudVT_45ICpdu5hIeSN7cgxXKJIfRtCYI93Mx8Meta } from "E:/W2/CDVM_V2/VM.Cms/pages/account/login.vue?macro=true";
import { default as indexBFn2LrdyMXANb99A66Ptl5mRo1ddHwvLzlQ3maVLVoIMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/receipt/index.vue?macro=true";
import { default as indexTyO7HRDk6rwQ0JFhjJAn3SpvtJn1HmDbuaRGklDH8LsMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/student/index.vue?macro=true";
import { default as pdf2imageU3qSHFyo2cWY72jDK3sjQT_45OzHUUfg0cFtIvis6OZwQMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/test/pdf2image.vue?macro=true";
import { default as _91type_93oO9p7vdZPwABJQU2xe9ek3EmlE_vJCiF8NCZSkGUEEcMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/category/[type].vue?macro=true";
import { default as toast_45demoz_Wch5cnK9O0Z3jt78M3UBNu9KFXOhHu9_OXIepjj8UMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/test/toast-demo.vue?macro=true";
import { default as settingszUzqLUpIZq5UCOT3j4ncgxa0yRUv5ck0u1EHaJN1ltkMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/account/settings.vue?macro=true";
import { default as file_45vieweruddN3LbZwkA1cRQnQrndMWLGtpmEfHDGZjhR1UBf1GIMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/test/file-viewer.vue?macro=true";
import { default as file_45managerzEH931Nl7Gfgb0MMrdU8zTSfgAiWohAsFoD8XXdnY7MMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/test/file-manager.vue?macro=true";
import { default as indexW5Vn_45P_45r6QtODYGoGTbHnKxpMSErPKAb2obbjZdZD6YMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/activity-log/index.vue?macro=true";
import { default as indexlABtPy_baLImCaU59TCNhFAUfYvHg_45M0XMfs5_45lynewMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/bank-account/index.vue?macro=true";
import { default as indexMEvy_xjgpRv03SNFmhXejx1QDqvg7jhfjuR7talqYAoMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/fee-schedule/index.vue?macro=true";
import { default as indexyjziuudt7ma5V1yMRBIxFt59_45KBlsnvpFdQM1BcRtRsMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/scholar-ship/index.vue?macro=true";
import { default as indexJSbdz28baH6AbDQ_45zLyFSnzlDrmoA5MIp43vuzXSAzgMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/academic-year/index.vue?macro=true";
import { default as indexao5PI0GTGlYB_GZ5vWHjbGtKzyjafixEnbk4ON_45RSWEMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/notifications/index.vue?macro=true";
import { default as forgot_45passwordS3cbCraNCmaFudNDA_45AxtAW95vDzNbcprqh6HbApDSUMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/account/forgot-password.vue?macro=true";
import { default as payment_45trackingD8hRJ5TIGEcRu6W7nGYPX2nkR_45GtL4Ok6FpgDZ7GfB8Meta } from "E:/W2/CDVM_V2/VM.Cms/pages/receipt/payment-tracking.vue?macro=true";
import { default as student_45statuslwADvTuXIeCzN93_45OnGAkQeYEWfP2oEanCsOl_456sD08Meta } from "E:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status.vue?macro=true";
import { default as student_45notification_45demoJEE_TmdDa2MU8NGlQKot4HA99egrLD1g764tQ8rm2BIMeta } from "E:/W2/CDVM_V2/VM.Cms/pages/test/student-notification-demo.vue?macro=true";
import { default as student_45status_45summaryJVniRFZxvlBv8TPUT0Nz9L845rFq6UP0u9uU01rdcX8Meta } from "E:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary.vue?macro=true";
export default [
  {
    name: "index___vi",
    path: "/",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/index.vue")
  },
  {
    name: "input___vi",
    path: "/input",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/input.vue")
  },
  {
    name: "input___en",
    path: "/en/input",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/input.vue")
  },
  {
    name: "builder___vi",
    path: "/builder",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/builder.vue")
  },
  {
    name: "builder___en",
    path: "/en/builder",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/builder.vue")
  },
  {
    name: "role___vi",
    path: "/role",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/role/index.vue")
  },
  {
    name: "role___en",
    path: "/en/role",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/role/index.vue")
  },
  {
    name: "class___vi",
    path: "/class",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/class/index.vue")
  },
  {
    name: "class___en",
    path: "/en/class",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/class/index.vue")
  },
  {
    name: "config___vi",
    path: "/config",
    meta: indexnEqOMnhfQVj9oyAGrPMWPoxTSulKtOfH3MduHa1OXwsMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/config/index.vue")
  },
  {
    name: "config___en",
    path: "/en/config",
    meta: indexnEqOMnhfQVj9oyAGrPMWPoxTSulKtOfH3MduHa1OXwsMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/config/index.vue")
  },
  {
    name: "parent-input___vi",
    path: "/parent-input",
    meta: parent_45inputKKiBnDJcqAW8QvwUwZE_zf1BUDlKc9gPXw5d3JmewH0Meta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/parent-input.vue")
  },
  {
    name: "parent-input___en",
    path: "/en/parent-input",
    meta: parent_45inputKKiBnDJcqAW8QvwUwZE_zf1BUDlKc9gPXw5d3JmewH0Meta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/parent-input.vue")
  },
  {
    name: "account___vi",
    path: "/account",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/account/index.vue")
  },
  {
    name: "account-login___vi",
    path: "/account/login",
    meta: logindPzKT4QTudVT_45ICpdu5hIeSN7cgxXKJIfRtCYI93Mx8Meta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: logindPzKT4QTudVT_45ICpdu5hIeSN7cgxXKJIfRtCYI93Mx8Meta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/account/login.vue")
  },
  {
    name: "receipt___vi",
    path: "/receipt",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/receipt/index.vue")
  },
  {
    name: "receipt___en",
    path: "/en/receipt",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/receipt/index.vue")
  },
  {
    name: "student___vi",
    path: "/student",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/student/index.vue")
  },
  {
    name: "student___en",
    path: "/en/student",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/student/index.vue")
  },
  {
    name: "test-pdf2image___vi",
    path: "/test/pdf2image",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/pdf2image.vue")
  },
  {
    name: "test-pdf2image___en",
    path: "/en/test/pdf2image",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/pdf2image.vue")
  },
  {
    name: "category-type___vi",
    path: "/category/:type()",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/category/[type].vue")
  },
  {
    name: "category-type___en",
    path: "/en/category/:type()",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/category/[type].vue")
  },
  {
    name: "test-toast-demo___vi",
    path: "/test/toast-demo",
    meta: toast_45demoz_Wch5cnK9O0Z3jt78M3UBNu9KFXOhHu9_OXIepjj8UMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/toast-demo.vue")
  },
  {
    name: "test-toast-demo___en",
    path: "/en/test/toast-demo",
    meta: toast_45demoz_Wch5cnK9O0Z3jt78M3UBNu9KFXOhHu9_OXIepjj8UMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/toast-demo.vue")
  },
  {
    name: "account-settings___vi",
    path: "/account/settings",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/account/settings.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/account/settings.vue")
  },
  {
    name: "test-file-viewer___vi",
    path: "/test/file-viewer",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-file-viewer___en",
    path: "/en/test/file-viewer",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-file-manager___vi",
    path: "/test/file-manager",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-manager___en",
    path: "/en/test/file-manager",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/file-manager.vue")
  },
  {
    name: "activity-log___vi",
    path: "/activity-log",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/activity-log/index.vue")
  },
  {
    name: "activity-log___en",
    path: "/en/activity-log",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/activity-log/index.vue")
  },
  {
    name: "bank-account___vi",
    path: "/bank-account",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/bank-account/index.vue")
  },
  {
    name: "bank-account___en",
    path: "/en/bank-account",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/bank-account/index.vue")
  },
  {
    name: "fee-schedule___vi",
    path: "/fee-schedule",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/fee-schedule/index.vue")
  },
  {
    name: "fee-schedule___en",
    path: "/en/fee-schedule",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/fee-schedule/index.vue")
  },
  {
    name: "scholar-ship___vi",
    path: "/scholar-ship",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/scholar-ship/index.vue")
  },
  {
    name: "scholar-ship___en",
    path: "/en/scholar-ship",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/scholar-ship/index.vue")
  },
  {
    name: "academic-year___vi",
    path: "/academic-year",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/academic-year/index.vue")
  },
  {
    name: "academic-year___en",
    path: "/en/academic-year",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/academic-year/index.vue")
  },
  {
    name: "notifications___vi",
    path: "/notifications",
    meta: indexao5PI0GTGlYB_GZ5vWHjbGtKzyjafixEnbk4ON_45RSWEMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/notifications/index.vue")
  },
  {
    name: "notifications___en",
    path: "/en/notifications",
    meta: indexao5PI0GTGlYB_GZ5vWHjbGtKzyjafixEnbk4ON_45RSWEMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/notifications/index.vue")
  },
  {
    name: "account-forgot-password___vi",
    path: "/account/forgot-password",
    meta: forgot_45passwordS3cbCraNCmaFudNDA_45AxtAW95vDzNbcprqh6HbApDSUMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/account/forgot-password.vue")
  },
  {
    name: "account-forgot-password___en",
    path: "/en/account/forgot-password",
    meta: forgot_45passwordS3cbCraNCmaFudNDA_45AxtAW95vDzNbcprqh6HbApDSUMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/account/forgot-password.vue")
  },
  {
    name: "receipt-payment-tracking___vi",
    path: "/receipt/payment-tracking",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/receipt/payment-tracking.vue")
  },
  {
    name: "receipt-payment-tracking___en",
    path: "/en/receipt/payment-tracking",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/receipt/payment-tracking.vue")
  },
  {
    name: "statistic-student-status___vi",
    path: "/statistic/student-status",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status.vue")
  },
  {
    name: "statistic-student-status___en",
    path: "/en/statistic/student-status",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status.vue")
  },
  {
    name: "test-student-notification-demo___vi",
    path: "/test/student-notification-demo",
    meta: student_45notification_45demoJEE_TmdDa2MU8NGlQKot4HA99egrLD1g764tQ8rm2BIMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/student-notification-demo.vue")
  },
  {
    name: "test-student-notification-demo___en",
    path: "/en/test/student-notification-demo",
    meta: student_45notification_45demoJEE_TmdDa2MU8NGlQKot4HA99egrLD1g764tQ8rm2BIMeta || {},
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/test/student-notification-demo.vue")
  },
  {
    name: "statistic-student-status-summary___vi",
    path: "/statistic/student-status-summary",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary.vue")
  },
  {
    name: "statistic-student-status-summary___en",
    path: "/en/statistic/student-status-summary",
    component: () => import("E:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary.vue")
  }
]